import { EncryptStorage } from 'encrypt-storage'

const { REACT_APP_ENCRYPT_STORAGE_KEY } = process.env

let encryptStorage = null
try {
  encryptStorage = new EncryptStorage(REACT_APP_ENCRYPT_STORAGE_KEY || 'password-please-default-key')
} catch (e) {
  encryptStorage = null
}

export const getStorageItem = key => {
  try {
    return encryptStorage ? encryptStorage.getItem(key) : null
  } catch (e) {
    return null
  }
}

export const setStorageItem = (key, value) => {
  try {
    if (!encryptStorage) return
    if (value) encryptStorage.setItem(key, value)
    else encryptStorage.removeItem(key)
  } catch (e) {}
}
